import { useQuery } from '@tanstack/react-query'
import { fetchProviders } from '../services/auth_service';

const GetUsers = () => {
 const getUsers = useQuery({
    queryKey:['users'],
    queryFn: fetchProviders
 })
 return getUsers;
}

export default GetUsers